import service from '@/store/services/vendors/labourer-payments-service';

const state = {
    list: [],
    labourerPayment: null,
    readyLabourers: [],
    labourerSchedules: [],
    meta: {},
    isLoading: false,
    error: null
};

const mutations = {
    SET_LIST(state, list) {
        state.list = list;
    },
    SET_RESOURCE(state, labourerPayment) {
        state.labourerPayment = labourerPayment;
    },
    SET_READY_LABOURERS(state, labourers) {
        state.readyLabourers = labourers;
    },
    SET_LABOURER_SCHEDULES(state, schedules) {
        state.labourerSchedules = schedules;
    },
    SET_META(state, meta) {
        state.meta = meta;
    },
    SET_LOADING(state, status) {
        state.isLoading = status;
    },
    SET_ERROR(state, error) {
        state.error = error;
    }
};

const actions = {
    list({ commit }, params) {
        params = params || {};
        return service.list(params)
            .then(function (response) {
                commit('SET_LIST', response.list);
                commit('SET_META', response.meta);
                return response;
            });
    },

    view({ commit }, params) {
        return service.viewPayment(params.id, {
            include: params.include || 'items,labourer'
        })
            .then(function (payment) {
                commit('SET_RESOURCE', payment);
                return payment;
            });
    },

    add({ commit }, params) {
        return service.createPayment(params)
            .then(function (payment) {
                commit('SET_RESOURCE', payment);
                return payment;
            });
    },

    update({ commit }, params) {
        return service.updatePayment(params)
            .then(function (payment) {
                commit('SET_RESOURCE', payment);
                return payment;
            });
    },

    destroy({ commit }, id) {
        return service.cancelPayment(id, {})
            .then(function (response) {
                return response;
            });
    },

    approvePaymentAction({ commit }, id) {
        commit('SET_LOADING', true);
        return service.approvePayment(id)
            .then(function (response) {
                commit('SET_LOADING', false);
                return response;
            })
            .catch(function (error) {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    markAsPaidAction({ commit }, id) {
        commit('SET_LOADING', true);
        return service.markAsPaid(id)
            .then(function (response) {
                commit('SET_LOADING', false);
                return response;
            })
            .catch(function (error) {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    cancelPaymentAction({ commit }, payload) {
        commit('SET_LOADING', true);
        return service.cancelPayment(payload.id, payload.data)
            .then(function (response) {
                commit('SET_LOADING', false);
                return response;
            })
            .catch(function (error) {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    async fetchReadyLabourersAction({ commit }, params) {
        return service.getReadyLabourers(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },


    async fetchLabourerSchedulesAction({ commit }, params) {
        commit('SET_LOADING', true);
        try {
            const response = await service.getLabourerSchedules(params);
            commit('SET_LABOURER_SCHEDULES', response);
            return response;
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    async createPaymentAction({ commit }, payload) {
        commit('SET_LOADING', true);
        try {
            return await service.createPayment(payload);
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    clearError({ commit }) {
        commit('SET_ERROR', null);
    }
};

const getters = {
    list: function (state) { return state.list; },
    listTotal: function (state) { return state.meta && state.meta.page ? state.meta.page.total : 0; },
    labourerPayment: function (state) { return state.labourerPayment; },
    readyLabourers: function (state) { return state.readyLabourers; },
    labourerSchedules: function (state) { return state.labourerSchedules; },
    meta: function (state) { return state.meta; },
    isLoading: function (state) { return state.isLoading; },
    error: function (state) { return state.error; }
};

export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};